import {
    Box,
    Button,
    Grid,
    InputAdornment,
    Popover,
    TextField,
    Typography,
} from "@mui/material";
import { AppLayout } from "layout";
import React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

const AccountStatusDropdown = ({
    activeDropdown,
    setAccountStatus,
    accountStatus,
    onStatusChange,
    onClearAll,
}: any) => {
    const handleClick = () => {
        setAccountStatus(2); // 2 is the index for this dropdown
    };
    const handleStatusSelection = (status: any) => {
        onStatusChange(status);
        setAccountStatus(null);
    };
    return (
        <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
            <Box onClick={handleClick} sx={styleSheet.CategoriesContainer}>
                {/* <FormatListBulletedIcon sx={{ width: "10.13px", height: "7.88px" }} /> */}
                {/* <img src="/assets/icons/category.png" alt="search" /> */}
                Account Status
            </Box>
            {activeDropdown == 2 && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "100%",
                        zIndex: 1,
                        width: { xs: "100%", md: 103 },
                        bgcolor: "background.paper",
                        borderRadius: "8px",
                        mt: 1,
                        p: 2,
                    }}
                >
                    <Box
                        display={"flex"}
                        flexDirection={"column"}
                        gap={2}
                        fontSize={"17px"}
                        fontWeight={400}
                        color={"#797979"}
                    >
                        {[
                            "Approve",
                            "Deactivated",
                            "Pending",

                        ].map((status) => (
                            <Typography
                                key={status}
                                onClick={() => handleStatusSelection(status)}
                                sx={{
                                    cursor: "pointer",
                                    color: accountStatus === status ? "#233F91" : "#797979", // ✅ Change color if selected

                                }}
                            >
                                {status}
                            </Typography>
                        ))}

                        <Box display="flex" alignItems="center" mb={2}>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    onClearAll(); // Trigger clear all
                                    setAccountStatus(null); // Close dropdown
                                }}
                            >
                                Clear
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </Grid>
    );
};

export default AccountStatusDropdown;

const styleSheet = {
    CategoriesContainer: {
        backgroundColor: "white",
        borderRadius: "15px",
        padding: "10px 10px",
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: "17px",
        fontWeight: "400px",
        // width: "122px",
        width: "116px",
        color: "#233F91",
        fontFamily: "Atten Round New",
    },
};
